// User.FlagDeveloper, read one way everywhere (Task 24761).
//
// It lived in helpers/functions/feedbackTool because that is where it was
// first needed, and a second copy had already appeared in pages/Tasks/single.
// The two did not agree: the copy used Boolean(...), which is TRUE for the
// string "0" - and the flag arrives from the API as a string - so on that
// screen every user counted as a developer. That is the kind of divergence a
// second copy always eventually produces, so there is now one definition.
//
// Compare as a string against "1": the value comes back as "1"/"0" from the
// API but as 1/0 from some cached shapes, and both must read the same.

const readAuthUser = () => {
  try {
    return JSON.parse(localStorage.getItem("authUser") || "{}") || {};
  } catch (e) {
    return {};
  }
};

export const isDeveloperUser = () =>
  String(readAuthUser()?.get_user_data?.User_FlagDeveloper) === "1";

export default isDeveloperUser;
